import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_MERCHANT_AGREEMENTS
} from "./actionTypes"

import {
  getMerchantAgreementsSuccess,
  merchantAgreementsApiError
} from "./actions"

import {
  getMerchantAgreementsList
} from "../../helpers/backend_helper/backend_helper"

function* fetchMerchantAgreements() {
  try {
    const response = yield call(getMerchantAgreementsList)
    yield put(getMerchantAgreementsSuccess(response))
  } catch (error) {
    yield put(merchantAgreementsApiError(error))
  }
}

function* merchantAgreementManagementSaga() {
  yield takeEvery(GET_MERCHANT_AGREEMENTS,fetchMerchantAgreements)
}

export default merchantAgreementManagementSaga